import { DEFAULT_APP } from '../../app-name/constants/default-app.ts';

export const EnvironmentVariableEnum = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,
  MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  PLATFORM_MAGIC_LINK_URL: import.meta.env.VITE_PLATFORM_MAGIC_LINK_URL as string,
  APP_NAME: (import.meta.env.VITE_APP_NAME as string) ?? DEFAULT_APP,
} as const;
